import L from "leaflet"

// Configure Leaflet default icons
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

export class MapConfig {
  static getTileLayerOptions() {
    return {
      url: 'https://tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=627980bbb5b04faeb6b40ed3da780323',
      options: {
        minZoom: 12,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    };
  }

  static getOSMTileLayerOptions() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        attribution: '&copy; OpenStreetMap contributors'
      }
    };
  }

  static getSatelliteTileLayerOptions() {
    return {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      options: {
        // Esri imagery for this region only has tiles up to ~z18; beyond that Leaflet
        // upscales the last real tiles instead of requesting Esri's "no data" placeholders.
        maxNativeZoom: 18,
        maxZoom: 20,
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community'
      }
    };
  }

  // Build the set of switchable base layers for the layers control.
  // The Thunderforest "Teren" layer is only offered when the user is on a plan that grants it.
  static getBaseLayers(layerType) {
    const layers = {};

    if (layerType === 'thunderforest') {
      const terrain = this.getTileLayerOptions();
      layers['Teren'] = L.tileLayer(terrain.url, terrain.options);
    }

    const osm = this.getOSMTileLayerOptions();
    layers['Karta'] = L.tileLayer(osm.url, osm.options);

    const satellite = this.getSatelliteTileLayerOptions();
    layers['Satelit'] = L.tileLayer(satellite.url, satellite.options);

    return layers;
  }

  static getLocateControlOptions() {
    return {
      drawCircle: false,
      setView: true,
      watch: true,
      keepCurrentZoomLevel: true,
      locateOptions: {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 10000
      },
      strings: { 
        title: "Lociraj me" 
      }
    };
  }
}
